import styled, { keyframes } from 'styled-components';

/**
 * Skeleton placeholder component for lazy-loaded widgets.
 * Displays a shimmer animation while waiting for the widget to become visible
 * and start loading. Matches the base widget styling for seamless transition.
 */
const WidgetSkeletonPlaceholder = () => {
  return (
    <SkeletonContainer>
      <SkeletonHeader>
        <SkeletonTitle />
        <SkeletonControls>
          <SkeletonButton />
        </SkeletonControls>
      </SkeletonHeader>
      <SkeletonContent>
        <SkeletonChart />
      </SkeletonContent>
    </SkeletonContainer>
  );
};

export default WidgetSkeletonPlaceholder;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const shimmerGradient = `
  linear-gradient(
    90deg,
    rgba(128, 128, 128, 0.06) 25%,
    rgba(128, 128, 128, 0.15) 50%,
    rgba(128, 128, 128, 0.06) 75%
  )
`;

const SkeletonContainer = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.widget_group.border};
  border-radius: 20px;
  background-color: ${({ theme }) => theme.widget.background};
  filter: drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.05));
  width: 100%;
  height: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
`;

const SkeletonHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;

const SkeletonTitle = styled.div`
  flex: 1;
  height: 24px;
  width: 60%;
  max-width: 200px;
  border-radius: 6px;
  background: ${shimmerGradient};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const SkeletonControls = styled.div`
  display: flex;
  gap: 8px;
`;

const SkeletonButton = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background: ${shimmerGradient};
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  animation-delay: 0.1s;
`;

const SkeletonContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SkeletonChart = styled.div`
  width: 100%;
  height: 100%;
  min-height: 120px;
  border-radius: 12px;
  background: ${shimmerGradient};
  background-size: 400px 100%;
  animation: ${shimmer} 1.8s ease-in-out infinite;
  animation-delay: 0.2s;
`;
